import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "objective-footer";

const keys = addTranslations(RESOURCE_NAME, {
    save_and_close: {
        en: "Save and close",
        fr: "Enregistrer et fermer",
    },
    validate: {
        en: "Validate",
        fr: "Valider",
    },
    fill_missing_required_inputs_tooltip: {
        en: "Fill in all required inputs before validating",
        fr: "Remplir tous les champs requis avant de valider",
    },
    edit: {
        en: "Edit",
        fr: "Modifier",
    },
    success_update: {
        en: "Objective updated successfully",
        fr: "Objectif mis à jour avec succès",
    },
    error_update: {
        en: "Error updating objective",
        fr: "Erreur lors de la mise à jour de l'objectif",
    },
    validate_contributor: {
        en: "Contributors cannot validate objectives",
        fr: "Les contributeurs ne peuvent pas valider un objectif",
    },
});

export function useObjectiveFooterTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
